import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'placeSelectedItemOnTopOfList',
  standalone: true,
})
export class PlaceSelectedItemOnTopOfListPipe implements PipeTransform {
  /**
   * Places `selectedItem` on top of `list`.
   *
   * If `selectedItem` is already present in `list`, it's left in place (not
   * reordered) - it's only inserted at the top when missing. Useful when
   * `list` comes from a filtered/searched source that may exclude the current
   * selection, so it stays visible.
   *
   * ```html
   * @for (
   *   item of items() | placeSelectedItemOnTopOfList : selectedItem();
   *   track item.id
   * ) {
   *   <nz-option [nzLabel]="item" [nzValue]="item.id" />
   * }
   * ```
   */
  transform<T extends { id: string }>(list: T[], selectedItem: T | null): T[] {
    if (!selectedItem || list.some((item) => item.id === selectedItem.id)) {
      return list;
    }
    return [selectedItem, ...list];
  }
}
